import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/apiClient'

export type PlanKey = 'MONTHLY_STANDARD' | 'YEARLY_ECO' | 'LIFETIME_PREMIUM'

export const useActivatePlanMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (plan: PlanKey) => {
      const { data } = await apiClient.patch('/owners/me/plan', { plan })
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['owner'] })
    },
  })
}
